type Props = {
  customer: Record<string, any>;
  clearCustomer?: () => void;
};

const CustomerCard = ({ customer, clearCustomer }: Props) => {
  return (
    <div className="p-2 rounded-sm flex flex-col my-2">
      <div className="bg-gray-50 p-4 rounded-xl">
        <div className="flex items-start justify-between mb-3">
          <h3 className="font-semibold text-gray-800">Customer details</h3>
          {clearCustomer && (
            <button
              type="button"
              onClick={clearCustomer}
              className="text-sm text-primary-600 hover:text-primary-700"
            >
              Clear
            </button>
          )}
        </div>

        <div className="text-sm text-gray-700 space-y-2">
          <div className="flex justify-between">
            <span className="font-medium text-gray-600">Name:</span>
            <span className="text-gray-900 text-right">{customer?.name || "—"}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-medium text-gray-600">Number:</span>
            <span className="text-gray-900 text-right">{customer?.phone || "—"}</span>
          </div>
          <div className="flex justify-between items-start">
            <span className="font-medium text-gray-600">Location:</span>
            <span className="text-gray-900 text-right max-w-[60%] break-words">{customer?.customerLocation || "—"}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerCard;
